<template>
  <section
    ref="section4"
    :class="[(Object.keys(validationErrors).length > 0 ? 'has-errors' : ''), 'mx-auto flex h-full flex-col']"
  >
    <v-add-listing-head
      :routes="routes"
      :step="4"
    ></v-add-listing-head>
    <main
      class="flex h-full flex-col items-center justify-between overflow-y-scroll px-4 py-8 md:px-12"
    >
      <figure class="flex max-w-xl flex-col gap-9 lg:w-full">
        <figure class="flex gap-3">
          <div><v-icon icon="house-dots" size="8"></v-icon></div>
          <div class="flex flex-col justify-center">
            <div class="text-heading-3-desktop">
              Izberite vrsto vaše nepremičnine
            </div>
          </div>
        </figure>
        <form method="POST" :action="routes.submitForm" id="select-estate-type-step">
          <v-csrf-token></v-csrf-token>
          <figure>
            <div
              class="grid grid-cols-2 grid-rows-2 gap-4 lg:flex lg:flex-wrap lg:justify-center items-stretch"
            >
              <div
                name="hisa"
                :class="['tile group relative w-full flex-col sm:flex-row lg:max-w-[171px]', (validationErrors.objektart ? 'has-errors' : '')]"

              >
                <input
                  type="radio"
                  name="objektart"
                  id="real_estate_type-1"
                  value="haus"
                  class="hidden"
                  v-model="estateType"
                />

                <label
                  for="real_estate_type-1"
                  class="flex cursor-pointer h-full flex-col items-center justify-center rounded-3xl bg-white p-4 text-sm font-medium text-gray-900 shadow transition-all aspect-square"
                >
                  <img
                    :src="$assetsUrl +'/images/hisa_3.webp'"
                    alt="Hiša"
                    class="pointer-events-none mb-4 w-20 select-none transition-all"
                  />

                  <span class="pointer-events-none select-none">Hiša</span>
                </label>
              </div>
              <div
                name="novogradnjahisa"
                :class="['tile group relative w-full flex-col sm:flex-row lg:max-w-[171px]', (validationErrors.objektart ? 'has-errors' : '')]"
                v-if="stepData.vermarktungsart != 'miete'"
              >
                <input
                  type="radio"
                  name="objektart"
                  id="real_estate_type-5"
                  value="hausbau"
                  class="hidden"
                  v-model="estateType"
                />

                <label
                  for="real_estate_type-5"
                  class="flex cursor-pointer h-full flex-col items-center justify-center rounded-3xl bg-white p-4 text-sm font-medium text-gray-900 shadow transition-all aspect-square"
                >
                  <img
                    :src="$assetsUrl +'/images/novogradnja_hisa.webp'"
                    alt="Novogradnja hiša"
                    class="pointer-events-none mb-4 w-20 select-none transition-all"
                  />

                  <span class="pointer-events-none select-none">Novogradnja hiša</span>
                </label>
              </div>
              <div
                name="stanovanje"
                :class="['tile group relative w-full flex-col sm:flex-row lg:max-w-[171px]', (validationErrors.objektart ? 'has-errors' : '')]"
              >
                <input
                  type="radio"
                  name="objektart"
                  id="real_estate_type-2"
                  value="wohnung"
                  class="hidden"
                  v-model="estateType"
                />

                <label
                  for="real_estate_type-2"
                  class="flex cursor-pointer h-full flex-col items-center justify-center rounded-3xl bg-white p-4 text-sm font-medium text-gray-900 shadow transition-all aspect-square"
                >
                  <img
                    :src="$assetsUrl +'/images/stanovanje_3.webp'"
                    alt="Stanovanje"
                    class="pointer-events-none mb-4 w-20 select-none transition-all"
                  />

                  <span class="pointer-events-none select-none">Stanovanje</span>
                </label>
              </div>
              <div
                name="stanovanje"
                :class="['tile group relative w-full flex-col sm:flex-row lg:max-w-[171px]', (validationErrors.objektart ? 'has-errors' : '')]"
                v-if="stepData.vermarktungsart != 'miete'"
              >
                <input
                  type="radio"
                  name="objektart"
                  id="real_estate_type-4"
                  value="ind_Schl_3259"
                  class="hidden"
                  v-model="estateType"
                />

                <label
                  for="real_estate_type-4"
                  class="flex cursor-pointer h-full flex-col items-center justify-center rounded-3xl bg-white p-4 text-sm font-medium text-gray-900 shadow transition-all aspect-square"
                >
                  <img
                    :src="$assetsUrl +'/images/novogradnja_stanovanje.webp'"
                    alt="Novogradnja stanovanje"
                    class="pointer-events-none mb-4 w-20 select-none transition-all"
                  />

                  <span class="pointer-events-none select-none text-center">Novogradnja stanovanje</span>
                </label>
              </div>
              <div
                name="parcela"
                :class="['tile group relative w-full flex-col sm:flex-row lg:max-w-[171px]', (validationErrors.objektart ? 'has-errors' : '')]"
                v-if="stepData.vermarktungsart != 'miete'"
              >
                <input
                  type="radio"
                  name="objektart"
                  id="real_estate_type-3"
                  value="grundstueck"
                  class="hidden"
                  v-model="estateType"
                />

                <label
                  for="real_estate_type-3"
                  class="flex cursor-pointer h-full flex-col items-center justify-center rounded-3xl bg-white p-4 text-sm font-medium text-gray-900 shadow transition-all aspect-square"
                >
                  <img
                    :src="$assetsUrl +'/images/parcela.webp'"
                    alt="Parcela"
                    class="pointer-events-none mb-4 w-20 select-none transition-all"
                  />

                  <span class="pointer-events-none select-none">Parcela</span>
                </label>
              </div>
              <div
                name="soba"
                :class="['tile group relative w-full flex-col sm:flex-row lg:max-w-[171px]', (validationErrors.objektart ? 'has-errors' : '')]"
                v-if="stepData.vermarktungsart != 'kauf'"
              >
                <input
                  type="radio"
                  name="objektart"
                  id="real_estate_type-0"
                  value="zimmer"
                  class="hidden"
                  v-model="estateType"
                />

                <label
                  for="real_estate_type-0"
                  class="flex cursor-pointer h-full flex-col items-center justify-center rounded-3xl bg-white p-4 text-sm font-medium text-gray-900 shadow transition-all aspect-square"
                >
                  <img
                    :src="$assetsUrl +'/images/soba_3.webp'"
                    alt="Soba"
                    class="pointer-events-none mb-4 w-20 select-none transition-all"
                  />

                  <span class="pointer-events-none select-none">Soba</span>
                </label>
              </div>
            </div>
          </figure>
        </form>
      </figure>
    </main>
    <v-add-listing-foot>
      <a
        @click="submitForm('select-estate-type-step')"
        :class="['button button--md h-[48px] w-[240px] px-6', (validated ? '' : 'button button--gray')]"
      >
        <label class="text-small-text-medium">Nadaljujte</label>
        <v-icon icon="arrow-right" size="4"></v-icon>
      </a>
    </v-add-listing-foot>
  </section>
</template>
<script>
import AddListingFootVue from '../AddListingFoot.vue';
import AddListingHeadVue from '../AddListingHead.vue';

export default {
  components: {
    "v-add-listing-foot": AddListingFootVue,
    "v-add-listing-head": AddListingHeadVue,
  },
  props: {
    old: {
      type: Object,
      required: false,
      default: {},
    },
    routes: {
      type: Object,
      required: true,
    },
    validationErrors: {
      type: Object,
      required: true,
      default: {},
    },
    stepData: {
      type: Object,
      required: true,
      default: {},
    },
  },
  data() {
    return {
      estateType: null,
    };
  },
  mounted() {
    this.estateType = this.stepData.objektart
  },
  methods: {
    submitForm(formId) {
      if(this.validated) document.getElementById(formId).submit();
    },
  },
  computed: {
    validated() {
      if(!this.estateType) {
        return false
      }

      return true;
    }
  }
};
</script>
